import axios from "axios";
import { FC, useCallback, useEffect, useState } from "react";
import { FiChevronRight, FiCopy, FiX } from "react-icons/fi";
import { IoIosArrowDropleftCircle, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { clearIntervalAsync } from 'set-interval-async';
import Swal from "sweetalert2";
import { Loading } from "../../components/Loading";
import { StyledTitle } from "../../components/StyledTitle";
import { findConsultById, updateConsult } from "../../hooks/usePayments";
import { contatoCommunix } from "../../services/contatoCommunix";
import theme from "../../styles/themes/default";
import { ButtonCopyPaste, DefaultContainer, DefaultContainerSummaryPix, DefaultDivPix, DefaultSpanListPix, DefaultTitlePix, DivCopyPaste, DivGrid, DivList, DivPixCodeNotification, DivPixQrCode, ModalPix, ModalPixButton, ModalPixContent, ModalPixContentTitle, ModalPixDetail, ModalPixDetailContainer, ModalPixDetailContainerDebt, ModalPixIconSuccessMessage, ModalPixSuccessMessage, PaymentSummaryPix, PixPaymentContainer, SpanQrCode, SpanWaitingPayment, TextAreaCopyPaste, TextSummaryPix, TextSummaryPixLink, TitleSummaryPix } from "./style";
import { usePayment } from "../../context/Payments";
import generatePix from "../../services/generatePix";
import { useUser } from "../../context/UserContext";
import { StyledCardInformationCar } from "../../components/StyledCardInformationsCar";


const PixPayment: FC = () => {

    const {
        ipvaSelected,
        licenciamentoSelected,
        dpvatSelected,
        multasSelected,
        outrosSelected,
        cupom,
        consultCode,
        pix,
        vehicle
    } = usePayment();

    const [pixQrCodeBase64, setPixQrCodeBase64] = useState<string>('');
    const [pixCopiaCola, setPixCopiaCola] = useState<string>('');
    const [isPixCopied, setIsPixCopied] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const { user } = useUser();
    const [modalPixSuccess, setModalPixSuccess] = useState(false);
    const [modalDetail, setShowModalDetail] = useState(false);
    const [storeData, setStoreData] = useState<any>({});




    const navigate = useNavigate();



    const copyTextToClipboard = useCallback(async (text: string) => {
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand('copy', true, text);
        }
    }, []);

    useEffect(() => {
        if (!isPixCopied) return;
        const timer = setTimeout(() => {
            setIsPixCopied(false);
        }, 2500);
        return () => { clearTimeout(timer) };
    }, [isPixCopied]);

    useEffect(() => {
        const getPix = async () => {
            try {
                setLoading(true);
                const cnpj = '64032287000114';
                const telefone = user?.phone?.replace(/\+/g, '');

                const checkContato = window.localStorage.getItem(
                    `Zignet:Contato:${consultCode}`
                );

                if (checkContato !== 'true') {
                    await contatoCommunix({
                        consulta: String(consultCode),
                        telefone: telefone ? telefone?.substring(2) : '',
                        cnpj,
                        email: user?.email ?? '',
                        nome: user?.name ?? '',
                    }).then((response) => {
                        window.localStorage.setItem(
                            `Zignet:Contato:${consultCode}`,
                            response.sucesso
                        );
                    });
                }

                const dataPix = {
                    name: user?.name || '',
                    cnpj,
                    pix,
                    cupom,
                    email: user?.email || "",
                    phone: user?.phone || "",
                    ipvaSelected,
                    licenciamentoSelected,
                    dpvatSelected,
                    multasSelected,
                    outrosSelected,
                    consultCode,
                    sub: user?.sub || ""
                };

                const consulta = await findConsultById(consultCode);

                if (consulta?.payloadCaptura) {
                    setLoading(false);

                    window.localStorage.setItem(
                        'zignet:PayloadCaptura',
                        JSON.stringify(consulta?.payloadCaptura)
                    );
                    window.localStorage.setItem(
                        'zignet:PayloadComprovante',
                        JSON.stringify(consulta?.payloadComprovante)
                    );
                    Swal.fire({
                        icon: 'warning',
                        html: `Já existe um pagamento em andamento para este veículo;`,
                        confirmButtonColor: theme.colors.orange.primary,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            console.log('Botão de confirmação clicado');
                            navigate('/proof');
                        }
                    });

                    
                    return;
                }

                const result = await generatePix(dataPix);

                console.log('result',result);

                const { copiaCola, qrCode, sucesso } = result;



                if (sucesso) {
                    findConsultById(consultCode).then(async (storageConsult) => {
                        if (storageConsult !== 'There is no such consult') {
                            const data = {
                                ...storageConsult,
                                subUsuario:
                                    storageConsult.subUsuario ?? user?.sub ?? null,
                                userPool: 'Cadastro',
                                dataConsulta: {
                                    ...storageConsult?.dataConsulta,
                                    nome: user?.name
                                },
                                email: user?.email,
                                payloadCaptura: dataPix,
                                payloadComprovante: result.data,
                                subStatus: 'payment'
                            };

                            const updatedConsult = await updateConsult(data).catch((e) => {
                                console.log(
                                    '🚀 ~ file: index.tsx:1429 ~ updatedConsult ~ e',
                                    e
                                );
                                return undefined;
                            });
                        }
                    });
                }

                setPixQrCodeBase64(qrCode);
                setPixCopiaCola(copiaCola);
                setLoading(false);
            } catch (err: any) {
                console.log('GeneratePix Catch: ', { err });
                if (err?.response?.data?.warning) {
                    Swal.fire({
                        icon: 'warning',
                        html: `Valor divergente do Débito.`,
                        confirmButtonColor: theme.colors.orange.primary,
                    });
                    setLoading(false);
                    return;
                }

                setLoading(false);
            }
        };
        if (user && Number(pix?.totalPrice?.replace(',', '.')) > 0 && pix.month > 0) {
            getPix();
        }
    }, [
        consultCode,
        cupom,
        dpvatSelected,
        ipvaSelected,
        licenciamentoSelected,
        multasSelected,
        outrosSelected,
        pix,
        user,
    ]);

    useEffect(() => {
        const clear = async (timer: any) => await clearIntervalAsync(timer);
        const timer = setInterval(async () => {
            if (consultCode && !modalPixSuccess) {
                const storageConsult = await findConsultById(consultCode);
                window.addEventListener('beforeunload', async () => await clear(timer));
                if (String(storageConsult?.status).toLowerCase() === 'aprovado' || String(storageConsult?.status).toLowerCase() === 'liquidado') {
                    if (modalDetail === true) setShowModalDetail(false);
                    setModalPixSuccess(true);
                    await clear(timer);
                }
            }
        }, 10000);
        return () => {
            window.removeEventListener('beforeunload', async () => await clear(timer));
            clearInterval(timer);
        };
    }, [consultCode, modalDetail, modalPixSuccess]);


    useEffect(() => {
        const store = window.localStorage.getItem('zignet:PayloadCaptura');

        if (store) {
            const parsedJSON = JSON.parse(store);
            console.log(
                '🚀 ~ file: index.tsx ~ line 1491 ~ useEffect ~ parsedJSON',
                parsedJSON
            );

            if (!parsedJSON?.[0]?.payloadCaptura) {
                return;
            }

            const {
                consultCode,
                installment,
                dpvatSelected,
                ipvaSelected,
                licenciamentoSelected,
                multasSelected,
                outrosSelected
            } = JSON.parse(parsedJSON?.[0]?.payloadCaptura);

            if (
                consultCode &&
                installment &&
                dpvatSelected &&
                ipvaSelected &&
                licenciamentoSelected &&
                multasSelected &&
                outrosSelected
            ) {
                setStoreData({
                    consultCode,
                    installment,
                    dpvatSelected,
                    ipvaSelected,
                    licenciamentoSelected,
                    multasSelected,
                    outrosSelected
                });
            }

            window.localStorage.removeItem('zignet:PayloadCaptura');
        }
    }, []);

    return (
        <>
            {loading && <Loading position="fixed" />}
            {modalDetail &&
                <ModalPix>
                    <ModalPixContent>
                        <ModalPixContentTitle>Detalhes do pedido</ModalPixContentTitle>
                        <ModalPixDetail>
                            {ipvaSelected.length > 0 && (
                                <ModalPixDetailContainer>
                                    <h2>IPVA</h2>
                                    {ipvaSelected.map((ipva) => (
                                        <ModalPixDetailContainerDebt>
                                            <p>
                                                {ipva.descricao} - {ipva.descricaoAdicional}
                                            </p>
                                            <p>
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(ipva.valor)}
                                            </p>
                                        </ModalPixDetailContainerDebt>
                                    ))}
                                </ModalPixDetailContainer>
                            )}
                            {dpvatSelected.length > 0 && (
                                <ModalPixDetailContainer>
                                    <h2>DPVAT</h2>
                                    {dpvatSelected.map((dpvat) => (
                                        <ModalPixDetailContainerDebt>
                                            <p>
                                                {dpvat.descricao} - {dpvat.descricaoAdicional}
                                            </p>
                                            <p>
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(dpvat.valor)}
                                            </p>
                                        </ModalPixDetailContainerDebt>
                                    ))}
                                </ModalPixDetailContainer>
                            )}
                            {multasSelected.length > 0 && (
                                <ModalPixDetailContainer>
                                    <h2>Multas</h2>
                                    {multasSelected.map((multa) => (
                                        <ModalPixDetailContainerDebt>
                                            <p>
                                                {multa.descricao} - {multa.descricaoAdicional}
                                            </p>
                                            <p>
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(multa.valor)}
                                            </p>
                                        </ModalPixDetailContainerDebt>
                                    ))}
                                </ModalPixDetailContainer>
                            )}
                            {licenciamentoSelected.length > 0 && (
                                <ModalPixDetailContainer>
                                    <h2>Licenciamento</h2>
                                    {licenciamentoSelected.map((licenciamento) => (
                                        <ModalPixDetailContainerDebt>
                                            <p>
                                                {licenciamento.descricao} -{' '}
                                                {licenciamento.descricaoAdicional}
                                            </p>
                                            <p>
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(licenciamento.valor)}
                                            </p>
                                        </ModalPixDetailContainerDebt>
                                    ))}
                                </ModalPixDetailContainer>
                            )}
                            {outrosSelected.length > 0 && (
                                <ModalPixDetailContainer>
                                    <h2>Outros</h2>
                                    {outrosSelected.map((outro) => (
                                        <ModalPixDetailContainerDebt>
                                            <p>
                                                {outro.descricao} - {outro.descricaoAdicional}
                                            </p>
                                            <p>
                                                {new Intl.NumberFormat('pt-BR', {
                                                    style: 'currency',
                                                    currency: 'BRL'
                                                }).format(outro.valor)}
                                            </p>
                                        </ModalPixDetailContainerDebt>
                                    ))}
                                </ModalPixDetailContainer>
                            )}
                            <ModalPixButton>
                                <button
                                    onClick={() => {
                                        setShowModalDetail(false);
                                    }}
                                >
                                    Fechar
                                    <FiX />
                                </button>
                            </ModalPixButton>
                        </ModalPixDetail>
                    </ModalPixContent>
                </ModalPix>}
            {modalPixSuccess &&
                <ModalPix>
                    <ModalPixContent>
                        <ModalPixIconSuccessMessage>
                            <img
                                src={'/icons/icon-circle-check-fill.svg'}
                                alt="Icone do modal de pix confirmado"
                            />
                        </ModalPixIconSuccessMessage>
                        <ModalPixDetail>
                            <ModalPixSuccessMessage>
                                <h2>
                                    Seu pagamento foi concluído
                                    <br /> com sucesso!
                                </h2>
                            </ModalPixSuccessMessage>
                            <ModalPixButton>
                                <button
                                    onClick={() => {
                                        setModalPixSuccess(false);
                                        navigate('/');
                                    }}
                                >
                                    Fechar
                                    <FiChevronRight />
                                </button>
                            </ModalPixButton>
                        </ModalPixDetail>
                    </ModalPixContent>
                </ModalPix>}
            <DefaultContainer>
                <PixPaymentContainer>
                    <StyledTitle marginTop={3.4} title=" Informações do veículo" />
                    <StyledCardInformationCar plate={vehicle.placa} uf={vehicle.uf} year={vehicle.ano?.toString()} brand={vehicle.marca} />
                    <StyledTitle marginTop={4.5} title=" Pagamento" />
                    <DefaultDivPix>
                        <DefaultTitlePix>
                            Siga as instruções a seguir para efetuar o seu pagamento:
                        </DefaultTitlePix>
                    </DefaultDivPix>
                    <DivList>
                        <DefaultSpanListPix>1. Acesse a opção PIX no seu Internet Banking ou app de pagamentos;</DefaultSpanListPix>
                        <DefaultSpanListPix>2. Escaneie o QR Code a seguir ou copie o código de pagamento;</DefaultSpanListPix>
                        <DefaultSpanListPix>3. Assim que recebermos seu pagamento, você receberá uma notificação no e-mail cadastrado. </DefaultSpanListPix>
                    </DivList>
                    <DivGrid>
                        {pixQrCodeBase64 ?
                            <DivPixQrCode>
                                {pixQrCodeBase64 && (
                                    <img
                                        src={`data:image/jpeg;base64,${pixQrCodeBase64}`}
                                        alt="Pix Qr Code"
                                        width={160}
                                        height={160}
                                    />
                                )}
                            </DivPixQrCode>
                            :
                            <SpanQrCode>Não foi possivel mostrar o QRCode</SpanQrCode>
                        }
                        <SpanQrCode>Se preferir, copie o código abaixo para realizar o pagamento.</SpanQrCode>
                    </DivGrid>
                    <DivCopyPaste>
                        {isPixCopied && (
                            <DivPixCodeNotification>
                                Pix copiado com sucesso!
                            </DivPixCodeNotification>
                        )}
                        <TextAreaCopyPaste
                            name="pixcode"
                            defaultValue={pixCopiaCola}
                            rows={2}
                            readOnly
                        ></TextAreaCopyPaste>
                        <ButtonCopyPaste
                            onClick={(e) => {
                                e.preventDefault();
                                copyTextToClipboard(pixCopiaCola);
                                setIsPixCopied(true);
                            }}
                        >
                            <FiCopy size={16} />
                        </ButtonCopyPaste>
                    </DivCopyPaste>
                    <DivGrid>
                        <SpanWaitingPayment color="rgba(66, 66, 66, 1)" weight={300}>Estamos verificando seu pagamento, aguarde...  </SpanWaitingPayment>
                        <SpanWaitingPayment color="rgba(245, 130, 32, 1)" weight={400}>Efetue o pagamento em até <SpanWaitingPayment color="rgba(245, 130, 32, 1)" weight={700}>30 minutos.</SpanWaitingPayment></SpanWaitingPayment>
                    </DivGrid>
                </PixPaymentContainer>
                <PaymentSummaryPix>
                    <DefaultContainerSummaryPix display={'flex'} marginTop={6}>
                        <TitleSummaryPix>
                            Resumo do pedido:
                        </TitleSummaryPix>
                    </DefaultContainerSummaryPix>
                    <DefaultContainerSummaryPix display={'grid'} marginTop={6}>
                        <TextSummaryPix fontSize={14} fontWeight={400}>
                            Pix (à vista)
                        </TextSummaryPix>
                        <TextSummaryPix fontSize={14} fontWeight={600} marginTop={8}>
                            Total: {pix.totalPrice
                                ? new Intl.NumberFormat('pt-BR', {
                                    currency: 'BRL',
                                    style: 'currency'
                                }).format(Number(pix.totalPrice))
                                : 'R$ 0,00'}
                        </TextSummaryPix>
                    </DefaultContainerSummaryPix>
                    <DefaultContainerSummaryPix gap={8} display={'flex'} marginTop={4}>
                        <TextSummaryPixLink color={'rgba(245, 130, 32, 1)'} textDecoration={'underline'} fontSize={14} fontWeight={400}
                            onClick={() => setShowModalDetail(true)}
                        >
                            Detalhe do pedido
                        </TextSummaryPixLink>
                        <IoIosArrowForward style={{ marginTop: '4px', color: 'rgba(245, 130, 32, 1)' }} />
                    </DefaultContainerSummaryPix>
                    <DefaultContainerSummaryPix display={'flex'} marginTop={4}>
                        <TextSummaryPix fontSize={14} fontWeight={400}>
                            Número do pedido: <TextSummaryPix fontSize={14} fontWeight={600}>{consultCode !== 0 ? consultCode : storeData?.consultCode}</TextSummaryPix>
                        </TextSummaryPix>
                    </DefaultContainerSummaryPix>
                    <DefaultContainerSummaryPix display={'flex'} marginTop={4} marginRight={2}>
                        <TextSummaryPix fontSize={14} fontWeight={400}>
                            O pagamento via PIX é realizado no mesmo dia, junto ao órgão emissor, quando é feito até as 17:30h no site da Zignet. Em casos de transações realizadas após esse horário, o pagamento é realizado no dia útil seguinte. O prazo de baixa dos débitos varia de acordo com cada órgão, podendo levar até 5 dias úteis para que os débitos sejam baixados no sistema. Em caso de dúvidas, nos chame no WhatsApp (11) 94549-1306.
                        </TextSummaryPix>
                    </DefaultContainerSummaryPix>
                    <DefaultContainerSummaryPix gap={4} display={'flex'} marginTop={4} justifyContent={'center'} marginRight={2}>
                        <IoIosArrowDropleftCircle style={{ marginTop: '3px', color: 'rgba(245, 130, 32, 1)', fontSize: '16px' }} />
                        <TextSummaryPix color={'rgba(245, 130, 32, 1)'} textDecoration={'underline'} fontSize={14} fontWeight={400}>
                            Voltar
                        </TextSummaryPix>
                    </DefaultContainerSummaryPix>
                </PaymentSummaryPix>
            </DefaultContainer>
        </>
    );
}


export default PixPayment;